module.exports = __webpack_public_path__ + "static/media/education-apiled.4938bac8.png";